export default __webpack_public_path__ + "static/3-b6ca4a3778528a89d073463719dad8df.jpeg";